import { MultiCheckDropdown, RichTextEditor } from 'Components';
import { GET_EMAIL_TEMPLATE_LIST_BY_CATEGORY_URL, GET_QUESTION_LIST_BY_PROJECT_URL, WORKFLOWS_ADMIN_PDF_API, WORKFLOWS_ADMIN_STATUS_API, WORKFLOWS_SAVE_SETTING_API, GET_OPERATOR_LIST_BY_PROJECT_QUESTIONS_URL, GET_VALUES_LIST_BY_PROJECT_QUESTIONS_URL } from 'Constant/api';
import { useActionList, useEmailTemplateCategoryList, useRoleList, useStageList } from 'Constant/apiHooks';
import { t } from 'i18next';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { authService } from 'Service/Axios';
import { v4 as uuid } from "uuid";

const Settingbar = ({ val, setVal, setNodes, handleDelete, selectedNodes, setSelectedNodes, workflowDetail, nodes }) => {
    const defaultIds = {
        mainConditionsId: uuid(),
        questionId: uuid(),
        defaultId: uuid(),
    };
    const defaultQuestionsCondions = {
        id: defaultIds.questionId,
        condition: "AND",
        questionId: "",
        operator: "",
        values: [],
    };
    const defaultMainConditions = {
        id: defaultIds.mainConditionsId,
        condition: "AND",
        questions: [
            {
                ...defaultQuestionsCondions,
            },
        ],
        if: "ALL",
    };
    const [mainConditions, setMainConditions] = useState([{
        id: defaultIds.defaultId,
        default: [
            {
                ...defaultMainConditions,
            },
        ]
    }]);
    const [nextNodeId, setNextNodeId] = useState("");
    const [questionData, setQuestionData] = useState(null);

    const handleAddNewRule = () => {
        setMainConditions([...mainConditions, {
            id: defaultIds.defaultId,
            default: [
                {
                    ...defaultMainConditions,
                },
            ]
        }]);
    }

    const handleAddMainConditions = (id) => {
        setMainConditions([...mainConditions.filter(i => i.id != id), {
            ...mainConditions.filter(i => i.id == id)[0], default: [...mainConditions.filter(i => i.id == id)[0].default, {
                ...defaultMainConditions,
            }]
        }]);
    };

    const handleDeleteMainCondition = (id) => {
        const deletedArr = mainConditions.filter(i => i.id != id);
        setMainConditions(deletedArr);
    };

    const handleAddQuestionsConditions = (id, index) => {
        const newArr = [...mainConditions.filter(i => i.id == id)[0].default];
        newArr[index].questions.push(defaultQuestionsCondions);
        setMainConditions([...mainConditions.filter(i => i.id != id), {
            ...mainConditions.filter(i => i.id == id)[0], default: newArr
        }]);
    };

    const handleDeleteQuestionsCondition = (id, mainId, questionId) => {
        const updatedQuestionData = { ...questionData };
        delete updatedQuestionData[questionId];
        setQuestionData(updatedQuestionData);
        const updatedData = mainConditions.filter(i => i.id == id)[0].default.map((item) => {
            if (item.id === mainId) {
                const updatedQuestions = item.questions.filter(
                    (question) => question.id !== questionId
                );
                return { ...item, questions: updatedQuestions };
            }
            return item;
        });
        setMainConditions([...mainConditions.filter(i => i.id != id), {
            ...mainConditions.filter(i => i.id == id)[0], default: updatedData
        }]);
    };

    const handleChangeMainConditions = (id, e, index) => {
        const newArr = [...mainConditions.filter(i => i.id == id)[0].default];
        newArr[index][e.target.name] = e.target.value;
        setMainConditions([...mainConditions.filter(i => i.id != id), {
            ...mainConditions.filter(i => i.id == id)[0], default: newArr
        }]);
    };

    const handleChangeQuestionsConditions = (
        id,
        e,
        mainIndex,
        quesIndex,
        value,
        questionId
    ) => {
        const newArr = [...mainConditions.filter(i => i.id == id)[0].default];
        newArr[mainIndex].questions[quesIndex][e.target.name] = value;
        if (e.target.name === "questionId") {
            getQuestionData(workflowDetail.projectId, value, questionId);
            newArr[mainIndex].questions[quesIndex].operator = "";
        }
        setMainConditions([...mainConditions.filter(i => i.id != id), {
            ...mainConditions.filter(i => i.id == id)[0], default: newArr
        }]);
    };

    const handleChangeQuestionsConditionsMultipleValues = (
        id,
        values,
        mainIndex,
        quesIndex
    ) => {
        const modifiedValues = values.map((option) => option.value);
        const newArr = [...mainConditions.filter(i => i.id == id)[0].default];
        newArr[mainIndex].questions[quesIndex].values = modifiedValues;
        setMainConditions([...mainConditions.filter(i => i.id != id), {
            ...mainConditions.filter(i => i.id == id)[0], default: newArr
        }]);
    };

    const questionValuesRender = (
        id,
        values,
        index,
        quesCond,
        quesIndex,
        selectValues
    ) => {
        if (values.designType === "select") {
            const options =
                values.dropdownValue &&
                values.dropdownValue.length > 0 &&
                values.dropdownValue.map((option) => ({
                    value: option.value,
                    label: option.name || "",
                }));
            const selectedValue =
                options && options.filter((obj) => selectValues.includes(obj.value));
            return (
                <MultiCheckDropdown
                    options={options}
                    value={selectedValue}
                    onChange={(values) =>
                        handleChangeQuestionsConditionsMultipleValues(
                            id,
                            values,
                            index,
                            quesIndex
                        )
                    }
                />
            );
        }
        return (
            <input
                type={values.designType}
                className="form-control form-control-md"
                name="values"
                value={quesCond.values}
                onChange={(e) =>
                    handleChangeQuestionsConditions(id, e, index, quesIndex, [e.target.value])
                }
            />
        );
    };

    const getQuestionData = async (projectId, questionId, qId) => {
        const payload = {
            questionId,
            projectId,
        };
        if (questionId && projectId) {
            const operatorResponse = await authService(
                GET_OPERATOR_LIST_BY_PROJECT_QUESTIONS_URL,
                "POST",
                payload
            );

            const valuesResponse = await authService(
                GET_VALUES_LIST_BY_PROJECT_QUESTIONS_URL,
                "POST",
                payload
            );
            if (operatorResponse && valuesResponse) {
                const newObject = {
                    [qId]: {
                        values: valuesResponse,
                        operator: operatorResponse,
                    },
                };
                setQuestionData((prevQuestionData) => ({
                    ...prevQuestionData,
                    ...newObject,
                }));
            } else {
                const newObject = {
                    [qId]: {
                        values: null,
                        operator: [],
                    },
                };
                setQuestionData((prevQuestionData) => ({
                    ...prevQuestionData,
                    ...newObject,
                }));
            }
        }
    };

    const {
        actionList,
        loading: actionLoading,
        fetchActionList,
    } = useActionList();

    const { stageList, loading: stageLoading, fetchStageList } = useStageList();

    const {
        roleList, loading: roleLoading, fetchRoleList
    } = useRoleList();

    const { categoryList, activeCategory, setActiveCategory, fetchCategoryList } =
        useEmailTemplateCategoryList();

    const [statusList, setStatusList] = useState([]);
    const getStatusList = async (projectId) => {
        try {
            const payload = {
                gid: projectId,
            };
            const response = await authService(
                WORKFLOWS_ADMIN_STATUS_API,
                "POST",
                payload
            );
            if (response) {
                setStatusList(response);
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const [pdfList, setPdfList] = useState([]);
    const getPdfList = async (projectId) => {
        try {
            const payload = {
                gid: projectId,
            };
            const response = await authService(
                WORKFLOWS_ADMIN_PDF_API,
                "POST",
                payload
            );
            if (response) {
                setPdfList(response);
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const [questionList, setQuestionList] = useState([]);
    const getQuestionList = async (projectId) => {
        try {
            const payload = {
                gid: projectId,
            };
            const response = await authService(
                GET_QUESTION_LIST_BY_PROJECT_URL,
                "POST",
                payload
            );
            if (response) {
                setQuestionList(response);
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const [emailTemplateList, setEmailTemplateList] = useState([]);
    const getEmailTemplateList = async (category) => {
        if (category) {
            const data = {
                category,
            };
            const response = await authService(
                GET_EMAIL_TEMPLATE_LIST_BY_CATEGORY_URL,
                "POST",
                data
            );
            setEmailTemplateList(response);
        }
    };

    useEffect(() => {
        getQuestionList(workflowDetail.projectId);
        getEmailTemplateList(val.templateID);
        getStatusList()
        getPdfList()
    }, [val.templateID, val.notificationDetails, val.trigger, val.waitType]);

    const handleSaveSettings = async () => {
        const payload = {
            gid: "",
            projectId: workflowDetail.projectId,
            workflowId: workflowDetail.workflowId,
            ...val
        }
        const response = await authService(WORKFLOWS_SAVE_SETTING_API, "POST", payload);
        if (response) {
            toast.success("Saved Setting!");
            setSelectedNodes([]);
        }
    }

    const handleChangeLabel = (e) => {
        const item = e.target.value;
        setVal({ ...val, label: item }); // Update the state with the new label and type
        setNodes((nds) =>
            nds.map((node) =>
                selectedNodes.find((n) => n.id === node.id)
                    ? { ...node, data: { ...node.data, label: item } }
                    : node
            )
        );
    };

    const handleChangeRole = (e) => {
        const item = e.target.value;
        setVal({ ...val, role: item });
    };

    const handleChangeEmail = (e, i) => {
        const item = val.email.map((item, index) => index === i ? e.target.value : item);
        setVal({ ...val, email: item });
    };

    const handleChangeDate = (e) => {
        const item = e.target.value;
        setVal({ ...val, date: item });
    };

    const handleChangeStages = (e) => {
        const item = e.target.value;
        setVal({ ...val, stages: item });
    };

    const handleChangeTargetFields = (e) => {
        const item = e.target.value;
        setVal({ ...val, targetFields: item });
    };

    const handleChangeTemplateID = (e) => {
        const item = e.target.value;
        setVal({ ...val, templateID: item });
    };

    const handleChangeGeneratePDF = (e) => {
        const item = e.target.value;
        setVal({ ...val, generatePDF: item });
    };

    const handleChangeStatus = (e) => {
        const item = e.target.value;
        setVal({ ...val, status: item });
    };

    const handleChangeTemplateName = (e) => {
        const item = e.target.value;
        setVal({ ...val, templateName: item });
    };

    const handleChangeUnit = (e) => {
        const item = e.target.value;
        setVal({ ...val, field: item });
    };

    const handleChangeTriggerType = (e) => {
        const item = e.target.value;
        setVal({ ...val, triggerType: item });
    };

    const handleChangetriggerDetails = (e) => {
        const item = e.target.value;
        setVal({ ...val, triggerDetails: item });
    };

    const handleChangeDescription = (e) => {
        const item = e.target.value;
        setVal({ ...val, description: item });
        setNodes((nds) =>
            nds.map((node) =>
                selectedNodes.find((n) => n.id === node.id)
                    ? { ...node, data: { ...node.data, description: item } }
                    : node
            )
        );
    }

    const handleChangeEndType = (e) => {
        const item = e.target.value;
        setVal({ ...val, endType: item });
    };

    const handleChangeActionType = (e) => {
        const item = e.target.value;
        setVal({ ...val, actionType: item });
    };

    const handleChangeActionConfig = (e) => {
        const item = e.target.value;
        setVal({ ...val, actionConfig: item });
    };

    const handleChangeNotificationType = (e) => {
        const item = e.target.value;
        setVal({ ...val, notificationType: item });
    }

    const handleChangeNotificationDetails = (e) => {
        const item = e.target.value;
        setVal({ ...val, notificationDetails: item });
    }

    const handleChangeLoopCount = (e) => {
        const item = e.target.value;
        setVal({ ...val, loopCount: item });
    }

    const handleChangeMaxDuration = (e) => {
        const item = e.target.value;
        setVal({ ...val, maxDuration: item });
    }

    const handleChangeDecisionButton = (e, i) => {
        const item = val.decisionButton.map((item, index) => index === i ? e.target.value : item);
        setVal({ ...val, decisionButton: item });
    };

    const handleChangeAmount = (e) => {
        const item = e.target.value;
        setVal({ ...val, timeOut: item });
    };

    const handleChangeWaitType = (e) => {
        const item = e.target.value;
        setVal({ ...val, waitType: item });
    };

    const handleChangeFieldName = (e) => {
        const item = e.target.value;
        setVal({ ...val, fieldName: item });
    };

    const handleChangeParagraphText = (value) => {
        setVal({ ...val, paragraph: value });
    };

    const handleAddNewEmail = () => {
        setVal({ ...val, email: [...val.email, ""] });
    }

    const handleAddNewDecisionButton = () => {
        setVal({ ...val, decisionButton: [...val.decisionButton, ""] });
    }

    return (
        <div className="formeditor-sidebar ms-auto bg-white global-tab h-100">
            <div className="p-3 h-100 d-flex flex-column">
                <div className="tab-content px-1">
                    <span className='text-sm font-medium grey-800'>General Setting</span>
                    {(selectedNodes[0].type == "start" || selectedNodes[0].type == "end" || selectedNodes[0].type == "action" || selectedNodes[0].type == "decision" || selectedNodes[0].type == "loop" || selectedNodes[0].type == "task" || selectedNodes[0].type == "wait" || selectedNodes[0].type == "notification") && <div className="mb-3 input-sm">
                        <label htmlFor="LabelText" className="form-label">Label</label>
                        <input
                            type="text"
                            className="form-control"
                            id="LabelText"
                            placeholder="Add Text"
                            value={val.label}
                            onChange={handleChangeLabel}
                        />
                    </div>}

                    {(selectedNodes[0].type == "start" || selectedNodes[0].type == "end" || selectedNodes[0].type == "action" || selectedNodes[0].type == "decision" || selectedNodes[0].type == "loop" || selectedNodes[0].type == "task" || selectedNodes[0].type == "wait" || selectedNodes[0].type == "notification") && <div className="mb-3 input-sm">
                        <label htmlFor="Description" className="form-label">Description</label>
                        <textarea
                            type="text"
                            className="form-control"
                            id="Description"
                            placeholder="Description"
                            value={val.description}
                            onChange={handleChangeDescription}
                            rows="4"
                        />
                    </div>}

                    {(selectedNodes[0].type == "start") && <div className="mb-3 input-sm">
                        <label
                            htmlFor="CalculateTriggerType"
                            className="form-label"
                        >
                            Trigger Type
                        </label>
                        <select
                            className="form-select"
                            id="CalculateTriggerType"
                            aria-label="Default select example"
                            value={val.triggerType}
                            onChange={handleChangeTriggerType}
                        >
                            <option value={'Event Based'}>Event Based</option>
                            <option value={'Time based'}>Time based</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "start" && val.triggerType == 'Event Based') && <div className="mb-3 input-sm">
                        <label
                            htmlFor="CalculateTriggerDetails"
                            className="form-label"
                        >
                            Trigger Details - Event
                            Name
                        </label>
                        <select
                            className="form-select"
                            id="CalculateTriggerDetails"
                            aria-label="Default select example"
                            value={val.triggerDetails}
                            onChange={handleChangetriggerDetails}
                        >
                            <option value={'Form Submission'}>Form Submission</option>
                            <option value={'Account Creation'}>Account Creation</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "start" && val.triggerType == 'Time based') && <div className="mb-3 input-sm">
                        <label htmlFor="fieldType" className="form-label">
                            Trigger Details - Start Time
                        </label>
                        <input
                            type="time"
                            className="form-control"
                            id="startTime"
                            placeholder="Choose date"
                            value={val.triggerDetails}
                            onChange={handleChangetriggerDetails}
                        />
                    </div>}

                    {(selectedNodes[0].type == "end") && <div className="mb-3 input-sm">
                        <label
                            htmlFor="CalculateEndType"
                            className="form-label"
                        >
                            End Type
                        </label>
                        <select
                            className="form-select"
                            id="CalculateEndType"
                            aria-label="Default select example"
                            value={val.endType}
                            onChange={handleChangeEndType}
                        >
                            <option value={'Success'}>Success</option>
                            <option value={'Error'}>Error</option>
                            <option value={'Terminated'}>Terminated</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "action") && <div className="mb-3 input-sm">
                        <label
                            htmlFor="CalculateActionType"
                            className="form-label"
                        >
                            Action Type
                        </label>
                        <select
                            className="form-select"
                            id="CalculateActionType"
                            aria-label="Default select example"
                            value={val.actionType}
                            onChange={handleChangeActionType}
                        >
                            <option value={''}>Select Option</option>
                            <option value={'targetFields'}>Target Fields</option>
                            <option value={'generatePDF'}>Generate PDF</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "action") && <div className="mb-3 input-sm">
                        <label
                            htmlFor="CalculateActionConfig"
                            className="form-label"
                        >
                            Action Config
                        </label>
                        <select
                            className="form-select"
                            id="CalculateActionConfig"
                            aria-label="Default select example"
                            value={val.actionConfig}
                            onChange={handleChangeActionConfig}
                        >
                            <option value={''}>Select Option</option>
                            <option value={'Applications'}>Applications</option>
                            <option value={'Status'}>Status</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "notification") && <div className="mb-3 input-sm">
                        <label
                            htmlFor="NotificationType"
                            className="form-label"
                        >
                            Notification Type
                        </label>
                        <select
                            className="form-select"
                            id="NotificationType"
                            aria-label="Default select example"
                            value={val.notificationType}
                            onChange={handleChangeNotificationType}
                        >
                            <option value={'Email'}>Email</option>
                            <option value={'SMS'}>SMS</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "notification") && <div className="mb-3 input-sm">
                        <label
                            htmlFor="NotificationDetails"
                            className="form-label"
                        >
                            Notification Details
                        </label>
                        <select
                            className="form-select"
                            id="NotificationDetails"
                            aria-label="Default select example"
                            value={val.notificationDetails}
                            onChange={handleChangeNotificationDetails}
                        >
                            <option value={'Role'}>Role</option>
                            <option value={'Email'}>Email</option>
                            <option value={'Dynamic'}>Dynamic</option>
                        </select>
                    </div>}

                    {((selectedNodes[0].type == "task") || (selectedNodes[0].type == "notification" && val.notificationDetails == 'Role')) && <div className="mb-3 input-sm">
                        <label
                            htmlFor="Role"
                            className="form-label"
                        >
                            Role
                        </label>
                        <select
                            className="form-select"
                            id="Role"
                            aria-label="Default select example"
                            value={val.role}
                            onChange={handleChangeRole}
                        >
                            <option value={'Select'}>Select</option>
                            {!roleLoading && roleList && roleList.length > 0 && roleList.map((folder) => (
                                <option value={folder.gid}>{folder.name}</option>
                            ))}
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "notification" && val.notificationDetails == 'Email' || selectedNodes[0].type == "task") && <>
                        {val.email && val.email.length > 0 && val.email.map((item, i) =>
                            <div className="mb-3 input-sm">
                                <label htmlFor="EmailAdress" className="form-label">Email Address</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="EmailAdress"
                                    placeholder=""
                                    value={item}
                                    onChange={(e) => handleChangeEmail(e, i)}
                                />
                            </div>
                        )}
                        <div className="bachcolor-color mt-5 mb-5">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-block d-flex justify-content-between align-items-center"
                                onClick={handleAddNewEmail}
                            >
                                Add New Email{" "}
                                <i className="bx bx-plus bx-sm"></i>
                            </button>
                        </div>
                    </>
                    }

                    {(selectedNodes[0].type == "action" && val.actionType == 'generatePDF') && <div className="mb-3 input-sm">
                        <label
                            htmlFor="generatePDF"
                            className="form-label"
                        >
                            Generate PDF
                        </label>
                        <select
                            className="form-select"
                            id="generatePDF"
                            aria-label="Default select example"
                            value={val.generatePDF}
                            onChange={handleChangeGeneratePDF}
                        >
                            {pdfList && pdfList.length > 0 && pdfList.map((folder) => (
                                <option value={folder.name}>{folder.name}</option>
                            ))}
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "action" && val.actionType == 'targetFields') && <div className="mb-3 input-sm">
                        <label
                            htmlFor="targetFields"
                            className="form-label"
                        >
                            Generate PDF
                        </label>
                        <select
                            className="form-select"
                            id="targetFields"
                            aria-label="Default select example"
                            value={val.targetFields}
                            onChange={handleChangeTargetFields}
                        >
                            <option value="">Select</option>
                            {questionList && questionList.length > 0 && questionList.map((folder) => (
                                <option value={folder.name}>{folder.name}</option>
                            ))}
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "notification") && <div className="mb-3 input-sm">
                        <span className='text-sm font-medium grey-800'>Template</span>
                        <label
                            htmlFor="Template"
                            className="form-label"
                        >
                            Category
                        </label>
                        <select
                            className="form-select"
                            id="Template"
                            aria-label="Default select example"
                            value={val.templateID}
                            onChange={handleChangeTemplateID}
                        >
                            <option value={'Select'}>Select</option>
                            {categoryList && categoryList.length > 0 && categoryList.map((folder) => (
                                <option value={folder.category}>{folder.category}</option>
                            ))}
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "task") && <>
                        {
                            val.decisionButton && val.decisionButton.length > 0 && val.decisionButton.map((item, i) => <div className="mb-3 input-sm">
                                <label
                                    htmlFor="DecisionButton"
                                    className="form-label"
                                >
                                    Decision Button
                                </label>
                                <select
                                    className="form-select"
                                    id="DecisionButton"
                                    aria-label="Default select example"
                                    value={item}
                                    onChange={(e) => handleChangeDecisionButton(e, i)}
                                >
                                    <option value={'Select'}>Select</option>
                                    {actionList && actionList.length > 0 && actionList.map((folder) => (
                                        <option value={folder.label}>{folder.label}</option>
                                    ))}
                                </select>
                            </div>)
                        }
                        <div className="bachcolor-color mt-5 mb-5">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-block d-flex justify-content-between align-items-center"
                                onClick={handleAddNewDecisionButton}
                            >
                                Add New Decision Button{" "}
                                <i className="bx bx-plus bx-sm"></i>
                            </button>
                        </div>
                    </>}


                    {(selectedNodes[0].type == "task") && <div className="mb-3 input-sm">
                        <label
                            htmlFor="Stages"
                            className="form-label"
                        >
                            Aggregation
                        </label>
                        <select
                            className="form-select"
                            id="Stages"
                            aria-label="Default select example"
                            value={val.stages}
                            onChange={handleChangeStages}
                        >
                            <option value={'Select'}>Select</option>
                            <option value={'Any'}>Any</option>
                            <option value={'All'}>All</option>
                            <option value={'Majority'}>Majority</option>
                            <option value={'Threshold'}>Threshold</option>
                            <option value={'Quorum'}>Quorum</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "loop") && <div className="mb-3 input-sm">
                        <label htmlFor="loopCount" className="form-label">Loop Count</label>
                        <input
                            type="text"
                            className="form-control"
                            id="loopCount"
                            placeholder="Loop Count"
                            value={val.loopCount}
                            onChange={handleChangeLoopCount}
                        />
                    </div>}

                    {(selectedNodes[0].type == "loop") && <div className="mb-3 input-sm">
                        <label htmlFor="maxDuration" className="form-label">Max Duration</label>
                        <input
                            type="text"
                            className="form-control"
                            id="maxDuration"
                            placeholder="Max Duration"
                            value={val.maxDuration}
                            onChange={handleChangeMaxDuration}
                        />
                    </div>}

                    {(selectedNodes[0].type == "decision") && <div className="mb-3 input-sm">
                        <span className='text-base font-medium grey-800'>Rulesets</span>

                        {mainConditions && mainConditions.length > 0 && mainConditions.map((item, i) =>
                            <div className='d-flex flex-column row-gap-2 mb-3 mt-3' key={item.id}>
                                {
                                    item.default?.map((mainCond, index) => (
                                        <div className="if-wrapper" key={mainCond.id}>
                                            <div className="step-row mb-4">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <label>{t("common.label.if")}</label>
                                                    {i !== 0 && (
                                                        <button
                                                            type="button"
                                                            className="delete-btn"
                                                            onClick={() =>
                                                                handleDeleteMainCondition(item.id)
                                                            }
                                                        >
                                                            <i className="bx bx-x"></i>
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="row align-items-center">
                                                    {index !== 0 && (
                                                        <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                                                            <div className="mb-4">
                                                                <select
                                                                    className="form-select form-select-md"
                                                                    name="condition"
                                                                    value={mainCond.condition}
                                                                    onChange={(e) =>
                                                                        handleChangeMainConditions(item.id, e, index)
                                                                    }
                                                                >
                                                                    <option value="AND">
                                                                        {t("common.label.and")}
                                                                    </option>
                                                                    <option value="OR">
                                                                        {t("common.label.or")}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                                                        <div className="mb-4">
                                                            <select
                                                                className="form-select form-select-md"
                                                                name="if"
                                                                value={mainCond.if}
                                                                onChange={(e) =>
                                                                    handleChangeMainConditions(item.id, e, index)
                                                                }
                                                            >
                                                                <option value="ALL">
                                                                    {t("common.label.all")}
                                                                </option>
                                                                <option value="ANY">
                                                                    {t("common.label.any")}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                                                        <div className="mb-4">
                                                            <strong>{t("auth.email.settings.ifRule")}</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                                {mainCond.questions &&
                                                    mainCond.questions.length > 0 &&
                                                    mainCond.questions.map((quesCond, quesIndex) => (
                                                        <div className="add-row-wrapper" key={quesCond.id}>
                                                            <div className="mb-4">
                                                                <select
                                                                    className="form-select form-select-md"
                                                                    name="questionId"
                                                                    value={quesCond.questionId}
                                                                    onChange={(e) =>
                                                                        handleChangeQuestionsConditions(
                                                                            item.id,
                                                                            e,
                                                                            index,
                                                                            quesIndex,
                                                                            e.target.value,
                                                                            quesCond.id
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="">Select</option>
                                                                    {questionList &&
                                                                        questionList.length > 0 &&
                                                                        questionList.map((qstn) => (
                                                                            <option
                                                                                value={qstn.questionId}
                                                                                key={qstn.questionId}
                                                                            >
                                                                                {qstn.name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                            <div className="mb-4">
                                                                <select
                                                                    className="form-select form-select-md"
                                                                    name="operator"
                                                                    value={quesCond.operator}
                                                                    onChange={(e) =>
                                                                        handleChangeQuestionsConditions(
                                                                            item.id,
                                                                            e,
                                                                            index,
                                                                            quesIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option>
                                                                        {t("common.label.select")}
                                                                    </option>
                                                                    <option value="equals">equals</option>
                                                                    <option value="not equals">
                                                                        not equals
                                                                    </option>
                                                                    <option value="in this list">
                                                                        in this list
                                                                    </option>
                                                                    <option value="not in this list">
                                                                        not in this list
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <div className="mb-4">
                                                                {questionData &&
                                                                    questionData[quesCond.id] &&
                                                                    questionData[quesCond.id].values ? (
                                                                    questionValuesRender(
                                                                        item.id,
                                                                        questionData[quesCond.id].values,
                                                                        index,
                                                                        quesCond,
                                                                        quesIndex,
                                                                        quesCond.values
                                                                    )
                                                                ) : (
                                                                    <input
                                                                        type="text"
                                                                        disabled
                                                                        className="form-control form-control-md"
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="d-flex gap-2 mb-4">
                                                                <button
                                                                    type="button"
                                                                    className="delete-btn"
                                                                    onClick={() =>
                                                                        handleAddQuestionsConditions(item.id, index)
                                                                    }
                                                                >
                                                                    <i className="bx bx-plus"></i>
                                                                </button>
                                                                {quesIndex !== 0 &&
                                                                    <button
                                                                        type="button"
                                                                        className="delete-btn"
                                                                        onClick={() =>
                                                                            handleDeleteQuestionsCondition(
                                                                                item.id,
                                                                                mainCond.id,
                                                                                quesCond.id
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="bx bx-x"></i>
                                                                    </button>}
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    ), item.id, i)
                                }
                                <div className="col-lg-4 col-md-5 col-sm-6 col-12">
                                    <div className="bachcolor-color">
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-block d-flex justify-content-between align-items-center"
                                            onClick={() => handleAddMainConditions(item.id)}
                                        >
                                            {t("common.label.and")}/{t("common.label.or")}{" "}
                                            <i className="bx bx-plus bx-sm"></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="then-wrapper mt-4">
                                    <div className="add-row-wrapper">
                                        <div className="step-row ">
                                            <label>{t("common.label.then")}</label>
                                            <div className="mb-4 mb-sm-0">
                                                <label htmlFor="nodenextText" className="form-label">Next Node ID</label>
                                                <select
                                                    className="form-select"
                                                    id="nodenextText"
                                                    aria-label="Default select example"
                                                    value={nextNodeId}
                                                    onChange={(e) => setNextNodeId(e.target.value)}
                                                >
                                                    <option value={'Select'}>Select</option>
                                                    {nodes && nodes.length > 0 && nodes.slice(selectedNodes[0].id).map((folder) => (
                                                        <option value={folder.data.label}>{folder.data.label}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="mb-3 input-sm">
                                                <label
                                                    htmlFor="Status"
                                                    className="form-label"
                                                >
                                                    Status
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="Status"
                                                    aria-label="Default select example"
                                                    value={val.status}
                                                    onChange={handleChangeStatus}
                                                >
                                                    <option value={'Select'}>Select</option>
                                                    {statusList && statusList.length > 0 && statusList.map((folder) => (
                                                        <option value={folder.name}>{folder.name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="mb-3 input-sm">
                                                <label
                                                    htmlFor="Stages"
                                                    className="form-label"
                                                >
                                                    Sub Status
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="Stages"
                                                    aria-label="Default select example"
                                                    value={val.stages}
                                                    onChange={handleChangeStages}
                                                >
                                                    <option value={'Select'}>Select</option>
                                                    {stageList && stageList.length > 0 && stageList.map((folder) => (
                                                        <option value={folder.name}>{folder.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        )}
                        <div className="bachcolor-color mt-3 mb-5">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-block d-flex justify-content-between align-items-center"
                                onClick={handleAddNewRule}
                            >
                                Add New Rule{" "}
                                <i className="bx bx-plus bx-sm"></i>
                            </button>
                        </div>
                        <div className="mb-3 input-sm">
                            <label htmlFor="defultnextText" className="form-label">Default Next Node ID</label>
                            <input
                                type="text"
                                className="form-control"
                                id="defultnextText"
                                placeholder=""
                            />
                        </div>
                    </div>
                    }

                    {(selectedNodes[0].type == "wait") && <div className="mb-3 input-sm">
                        <label
                            htmlFor="WaitType"
                            className="form-label"
                        >
                            Wait Type
                        </label>
                        <select
                            className="form-select"
                            id="WaitType"
                            aria-label="Default select example"
                            value={val.waitType}
                            onChange={handleChangeWaitType}
                        >
                            <option value={'Duration'}>Duration</option>
                            <option value={'UntilDateTime'}>Until Date Time</option>
                            <option value={'Condition'}>Condition</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "wait" && val.waitType == 'Duration') && <div className="mb-3 input-sm">
                        <label htmlFor="Amount" className="form-label">Amount</label>
                        <input
                            type="number"
                            className="form-control"
                            id="Amount"
                            placeholder="Amount"
                            value={val.amount}
                            onChange={handleChangeAmount}
                        />
                    </div>}

                    {(selectedNodes[0].type == "wait" && val.waitType == 'Duration') && <div className="mb-3 input-sm">
                        <label htmlFor="unit" className="form-label">
                            Unit
                        </label>
                        <select
                            className="form-select"
                            id="unit"
                            aria-label="Default select example"
                            value={val.unit}
                            onChange={handleChangeUnit}
                        >
                            <option value={'Minutes'}>Minutes</option>
                            <option value={'Hours'}>Hours</option>
                            <option value={'Days'}>Days</option>
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "wait" && val.waitType == 'UntilDateTime') && <div className="mb-3 input-sm">
                        <label htmlFor="date" className="form-label">
                            Date
                        </label>
                        <input
                            type="date"
                            className="form-control"
                            id="date"
                            placeholder="Choose date"
                            value={val.date}
                            onChange={handleChangeDate}
                        />
                    </div>}

                    {((selectedNodes[0].type == "task" && val.stages == 'Threshold') || (selectedNodes[0].type == "task" && val.stages == 'Quorum') || (selectedNodes[0].type == "wait" && val.waitType == 'Condition')) && <div className="mb-3 input-sm">
                        <label htmlFor="Value" className="form-label">Value</label>
                        <input
                            type="number"
                            className="form-control"
                            id="Value"
                            placeholder="Value"
                            value={val.amount}
                            onChange={handleChangeAmount}
                        />
                    </div>}

                    {(selectedNodes[0].type == "wait" && val.waitType == 'Condition') && <div className="mb-3 input-sm">
                        <label htmlFor="fieldName" className="form-label">
                            Field Name
                        </label>
                        <select
                            className="form-select"
                            id="fieldName"
                            aria-label="Default select example"
                            value={val.fieldName}
                            onChange={handleChangeFieldName}
                        >
                            <option value={''}>Select Option</option>
                            {questionList && questionList.length > 0 && questionList.map((folder) => (
                                <option value={folder.name}>{folder.name}</option>
                            ))}
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "notification") && <div className="mb-3 input-sm">
                        <label htmlFor="TemplateName" className="form-label">Template Name</label>
                        <select
                            className="form-select"
                            id="TemplateName"
                            aria-label="Default select example"
                            value={val.templateName}
                            onChange={handleChangeTemplateName}
                        >
                            <option value={''}>Select Option</option>
                            {emailTemplateList && emailTemplateList.length > 0 && emailTemplateList.map((folder) => (<option value={folder.name}>{folder.name}</option>))}
                        </select>
                    </div>}

                    {(selectedNodes[0].type == "notification") && <div className="mb-3 input-sm">
                        <label htmlFor="fieldName" className="form-label">
                            Text Editor
                        </label>
                        <RichTextEditor
                            value={val.paragraph}
                            onChange={handleChangeParagraphText}
                        />
                    </div>}

                </div>

                <div className="mt-3 d-grid gap-2">
                    <Button variant="dark" onClick={handleSaveSettings}>
                        <i className="bx bx-save bx-sm align-middle"></i> Save Properties
                    </Button>
                    <Button variant="gray-light" onClick={handleDelete}>
                        <i className="bx bx-globe bx-sm align-middle"></i> Delete Selected
                    </Button>
                </div>
            </div>
        </div >
    )
}

export default Settingbar